// extracted by mini-css-extract-plugin
module.exports = {"containerQR":"InvitationData_containerQR__2wR1N","containerInfo":"InvitationData_containerInfo__1zIp7","listConfirmation":"InvitationData_listConfirmation__1FJrT"};